import React, { useEffect } from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import InputOnlyNumber from "../../common/Input/InputOnlyNumber";
import InputText from "../../common/Input/InputText";

const AddUpdateModal = ({
  modalVisible,
  setModalVisible,
  selectedAction,
  clinicPackageFormData,
  handleAddOrUpdatePackage,
  pathologyServices,
  handlesetClinicPackageFormData,
  setInputError,
}) => {
  const [suggestedPrice, setSuggestedPrice] = React.useState({
    pt: 0,
    client: 0,
  });
  useEffect(() => {
    if (!modalVisible) {
      setSuggestedPrice({ pt: 0, client: 0 });
    }
  }, [modalVisible]);
  return (
    <>
      <Modal
        centered
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        size={"lg"}
      >
        <div className="modal-header">
          <h3 className="modal-title" id="exampleModalLabel">
            {selectedAction === "Update"
              ? "Update Clinic Package Master"
              : "Add Clinic Package Master"}
          </h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => setModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleAddOrUpdatePackage}>
            <div className="row">
              <div className="col-xl-6">
                <InputText
                  name="packageName"
                  value={clinicPackageFormData.packageName}
                  onChange={(e) => handlesetClinicPackageFormData(e)}
                  placeholder="Profile Name"
                  label="Package Name"
                  fieldName="packageName"
                  setInputTextError={setInputError}
                />
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label htmlFor="tests" className="col-form-label">
                    Test Name:
                  </label>
                  {clinicPackageFormData && (
                    <Select
                      isMulti
                      value={clinicPackageFormData?.serviceDetails?.map(
                        (service) => ({
                          value: service?.id,
                          label:
                            pathologyServices?.find(
                              (s) => s?._id === service?.id,
                            )?.profileName ||
                            pathologyServices?.find(
                              (s) => s?._id === service?.id,
                            )?.testName,
                          type: service?.type,
                        }),
                      )}
                      placeholder="Select Tests"
                      onChange={(selectedOptions) => {
                        let totalPt = 0;
                        let totalClient = 0;

                        const updatedServices = selectedOptions.map(
                          (option) => {
                            const service = pathologyServices.find(
                              (s) => s._id === option.value,
                            );

                            const pt = service?.pt_price || 0;
                            const client =
                              service?.client_price ??
                              service?.client_Price ??
                              service?.clientPrice ??
                              0;

                            totalPt += pt;
                            totalClient += client;

                            return {
                              id: service._id,
                              type: service.testType,
                            };
                          },
                        );
                        handlesetClinicPackageFormData({
                          target: {
                            name: "serviceDetails",
                            value: updatedServices,
                          },
                        });
                        setSuggestedPrice({
                          ptPrice: totalPt,
                          clientPrice: totalClient,
                        });
                      }}
                      options={[...(pathologyServices || [])].sort((a, b) =>
                      (a.profileName || a.testName || "").localeCompare(b.profileName || b.testName || "", undefined,
                   { sensitivity: "base" })).map((pathologyService) => ({
                    value: pathologyService?._id,
                   label:
                   pathologyService?.profileName ||
                   pathologyService?.testName,
                  type: pathologyService?.testType,
                  }))}
                    />
                  )}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <InputOnlyNumber
                    name="clientPrice"
                    setInputOnlyNumberError={setInputError}
                    value={clinicPackageFormData.clientPrice}
                    onChange={(e) => handlesetClinicPackageFormData(e)}
                    placeholder="Client Price"
                    label="Client Price:"
                    fieldName="Client Price"
                  />
                  {clinicPackageFormData?.serviceDetails?.length > 0 && (
                    <div className="mt-1">
                      <small>
                        Suggested Client Price:{" "}
                        <span className="text-success fw-bold">
                          ₹ {suggestedPrice?.clientPrice}
                        </span>
                      </small>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-xl-6">
                <InputOnlyNumber
                  name="pt_price"
                  value={clinicPackageFormData.pt_price}
                  onChange={(e) => handlesetClinicPackageFormData(e)}
                  placeholder="Patient Price"
                  label="Patient Price:"
                  fieldName="Patient Price"
                  setInputOnlyNumberError={setInputError}
                />
                {clinicPackageFormData?.serviceDetails?.length > 0 && (
                  <div className="mt-1">
                    <small>
                      Suggested Patient Price:{" "}
                      <span className="text-success fw-bold">
                        ₹ {suggestedPrice?.ptPrice}
                      </span>
                    </small>
                  </div>
                )}
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="offerPrice" className="col-form-label">
                    Offer Price:
                  </label>
                  <input
                    type="number"
                    name="offerPrice"
                    className="form-control"
                    placeholder="offerPrice"
                    value={clinicPackageFormData.offerPrice}
                    onChange={(e) => handlesetClinicPackageFormData(e)}
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="offerPrice" className="col-form-label">
                    Tax:
                  </label>
                  <input
                    type="number"
                    name="tax"
                    className="form-control"
                    placeholder="Tax"
                    value={clinicPackageFormData.tax}
                    onChange={(e) => handlesetClinicPackageFormData(e)}
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="status" className="col-form-label me-3">
                    Status:
                  </label>
                  <div className="d-flex justify-content-between align-items-center">
                    {["Active", "Inactive", "Deleted"].map((status) => (
                      <div className="form-check d-flex" key={status}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="status"
                          id={status.toLowerCase()}
                          value={status}
                          checked={clinicPackageFormData.status === status}
                          onChange={(e) => handlesetClinicPackageFormData(e)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={status.toLowerCase()}
                        >
                          {status}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success">
                {selectedAction === "Update" ? "Update" : "Save"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default AddUpdateModal;
